
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
components: {
InlineLoading,
Previewer
},
directives: {
TransferDom
},
data() {
return {
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}


}
},
isShow: false,
list: [],
arr: [],
solutionv: this.$route.params.solutionv,
isHide: this.$route.params.isHide
}
},
methods: {
show(index) {
if (this.arr[index].hasOwnProperty('src')) {
this.$refs.previewer.show(index)
return
}
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
const header = {
headers: {
token: token,
opid: opid
}
}
let arr = this.list.path
const order = this.$route.params.order
let path = this.solutionv === 1 ?
arr[index]['origin'] ? arr[index]['origin'] : arr[index] :
order.path[index]['origin'] ? order.path[index]['origin'] : order.path[index];
this.$vux.loading.show({text: '加载中'})
this.$http.get('api/v1/photos?path=' + path, header).then(res => {
this.$vux.loading.hide();
this.arr[index].src = 'data:image/jpeg;base64,' + res.data['value']
this.$refs.previewer.show(index)
})
},
},
created() {
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
if (this.solutionv === 1) {
this.list = this.$route.params.order

let arr = [], brr = [], index = 0;
arr = this.list.path
if (this.list.path.length !== 0) {
this.isShow = true
let decrypt = () => {
let path = arr[index]['thumb'] ? arr[index]['thumb'] : arr[index]
AjaxPlugin.$http.get('api/v1/photos?path=' + path, header)
.then(res => {
brr.push({msrc: 'data:image/jpeg;base64,' + res.data['value']})
index++
if (index < arr.length) {
decrypt()
} else {
this.isShow = false
}
})
}
decrypt()
this.arr = brr
}
} else {
const order = this.$route.params.order
this.list.describe = order.operator.name + '--' + order.record
if (order.path.length !== 0) {
this.isShow = true
order.path.forEach(item => {
let path = item['thumb'] ? item['thumb'] : item
this.$http.get('api/v1/photos?path=' + path, header).then(res => {
this.arr.push({msrc: 'data:image/jpeg;base64,' + res.data['value']})
this.isShow = this.arr.length !== order.path.length
})
})
}
}
},
beforeRouteLeave(to, from, next) {
if (to.name === 'makeMemo') {
to.params.solutionv = this.solutionv
to.params.isHide = this.isHide
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/prgsdetail.vue